<template>
  <div class="sidebar-chatbot-wrapper font-sans">

    <!-- Sidebar -->
    <aside
      ref="dialog"
      class="dark:bg-gray-800 bg-gray-400 dark:bg-opacity-100 sm:bg-opacity-50 dark:text-white text-gray-800 h-full fixed sm:left-0 top-0 p-[24px] transition-all"
      :class="openSidebar ? 'left-0 w-[300px]' : 'w-[300px] sm:w-[72px] -left-[300px]'"
    >

      <!-- Sidebar Button -->
      <button
        type="button"
        id="aside-button"
        class="aside-button fixed sm:relative left-[24px] sm:left-auto"
        :aria-label="openSidebar ? 'Collapse sidebar' : 'Expand sidebar'"
        @click="toggleSidebar()"
      >
        <svg v-if="!openSidebar" width="24" height="24" viewBox="0 0 24 24" class="dark:fill-white fill-gray-800" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM3.75 5.25H7.5V18.75H3.75V5.25ZM20.25 18.75H9V5.25H20.25V18.75Z"/>
        </svg>

        <svg v-else width="24" height="24" viewBox="0 0 24 24" class="dark:fill-white fill-gray-800" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM20.25 18.75H8.25V5.25H20.25V18.75Z"/>
        </svg>
      </button>

      <!-- Resources -->
      <div
        class="mt-[48px] sm:mt-[24px] transition-all"
        :class="openSidebar ? 'opacity-100 h-auto visible delay-100' : 'opacity-0 invisible h-0 delay-0'"
      >
        <!-- <p class="font-semibold text-[16px] leading-[24px]">Resources</p> -->

        <ul
          class="mt-[24px] text-[14px] leading-[20px] font-light flex flex-col gap-[28px]"
          v-if="sidebarItems"
        >
          <li
            class="flex items-center gap-[8px] hover:opacity-70 transition-all"
            v-for="(anchor, index) in sidebarItems" :key="index"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" class="dark:fill-light fill-gray-800" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.75 6.89296C18.7186 7.98098 18.2712 9.01554 17.5 9.78359L14.7851 12.5C14.3897 12.8976 13.9194 13.2127 13.4013 13.4273C12.8833 13.6419 12.3279 13.7516 11.7671 13.75H11.7632C11.193 13.7496 10.6285 13.6349 10.1033 13.4127C9.5781 13.1905 9.10274 12.8653 8.70532 12.4563C8.3079 12.0473 7.99648 11.5628 7.78945 11.0314C7.58242 10.5 7.48399 9.93256 7.49996 9.3625C7.50462 9.19674 7.57494 9.03962 7.69545 8.9257C7.81595 8.81179 7.97678 8.75041 8.14254 8.75507C8.3083 8.75974 8.46542 8.83006 8.57933 8.95056C8.69324 9.07107 8.75462 9.23189 8.74996 9.39765C8.73858 9.80072 8.8081 10.202 8.95443 10.5777C9.10076 10.9535 9.32092 11.2961 9.6019 11.5853C9.88288 11.8745 10.219 12.1044 10.5903 12.2615C10.9617 12.4187 11.3608 12.4997 11.764 12.5C12.1604 12.501 12.5531 12.4234 12.9193 12.2718C13.2855 12.1201 13.618 11.8974 13.8976 11.6164L16.6125 8.90156C17.1726 8.33438 17.4856 7.56862 17.4831 6.77149C17.4806 5.97435 17.1628 5.21057 16.5991 4.6469C16.0355 4.08324 15.2717 3.76547 14.4746 3.76298C13.6774 3.76048 12.9117 4.07346 12.3445 4.63359L11.4851 5.49296C11.367 5.60523 11.2096 5.66689 11.0466 5.6648C10.8837 5.66272 10.7279 5.59705 10.6127 5.4818C10.4974 5.36654 10.4318 5.21083 10.4297 5.04785C10.4276 4.88488 10.4893 4.72753 10.6015 4.60937L11.4609 3.75C11.8574 3.35338 12.3281 3.03876 12.8462 2.8241C13.3643 2.60945 13.9196 2.49896 14.4804 2.49896C15.0412 2.49896 15.5965 2.60945 16.1146 2.8241C16.6327 3.03876 17.1035 3.35338 17.5 3.75C17.9106 4.16168 18.2332 4.65263 18.4481 5.19295C18.663 5.73328 18.7657 6.31169 18.75 6.89296ZM8.51558 14.5047L7.65621 15.3641C7.37591 15.6462 7.04233 15.8698 6.67484 16.0219C6.30735 16.174 5.9133 16.2515 5.51558 16.25C4.91894 16.2495 4.33583 16.0722 3.83993 15.7405C3.34403 15.4087 2.95758 14.9374 2.72942 14.3861C2.50126 13.8348 2.44163 13.2283 2.55806 12.6431C2.67449 12.0579 2.96175 11.5204 3.38355 11.0984L6.09371 8.38359C6.52057 7.95447 7.0666 7.66362 7.66089 7.54881C8.25517 7.434 8.87025 7.50054 9.42623 7.73978C9.98222 7.97903 10.4534 8.37992 10.7786 8.89039C11.1039 9.40087 11.2681 9.99734 11.25 10.6023C11.2453 10.7681 11.3067 10.9289 11.4206 11.0494C11.5345 11.1699 11.6916 11.2403 11.8574 11.2449C12.0231 11.2496 12.184 11.1882 12.3045 11.0743C12.425 10.9604 12.4953 10.8033 12.5 10.6375C12.515 10.0571 12.4119 9.47976 12.197 8.94043C11.9822 8.4011 11.6599 7.91104 11.25 7.5C10.4493 6.6997 9.36363 6.25013 8.2316 6.25013C7.09957 6.25013 6.01388 6.6997 5.21324 7.5L2.49996 10.2148C1.90326 10.8113 1.49677 11.5712 1.33184 12.3986C1.16691 13.226 1.25096 14.0838 1.57336 14.8634C1.89575 15.6431 2.44203 16.3097 3.14315 16.779C3.84428 17.2482 4.66878 17.4992 5.51246 17.5C6.07329 17.5016 6.62888 17.392 7.14705 17.1774C7.66523 16.9628 8.13569 16.6476 8.53121 16.25L9.39058 15.3906C9.49173 15.2715 9.54457 15.1188 9.53869 14.9626C9.53281 14.8064 9.46863 14.6581 9.35881 14.5469C9.24899 14.4357 9.10149 14.3697 8.94541 14.3619C8.78932 14.3541 8.63597 14.405 8.51558 14.5047Z"/>
            </svg>

            <span class="dark:[&>*]:!text-white dark:!text-white text-gray-800 [&>*:hover]:!no-underline [&>*:hover]:text-white resources-item" v-html="anchor"></span>
          </li>
        </ul>
      </div>

      <!-- Sidebar nav -->
      <nav class="absolute bottom-[24px] left-[24px] flex flex-col gap-[24px] dark:text-white font-light text-[14px] leading-[20px]">
        <a
          :href="communityURL"
          target="_blank"
          class="flex gap-[8px] items-center hover:opacity-70 transition-all hover:!no-underline hover:text-white"
          :aria-label="communityURL ? 'Go to community home page' : 'Community home page (link not available)'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" class="dark:fill-white fill-gray-800 flex-shrink-0" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.5603 10.1887L13.0603 2.68875C12.779 2.40766 12.3977 2.24976 12 2.24976C11.6024 2.24976 11.221 2.40766 10.9397 2.68875L3.4397 10.1887C3.29973 10.3277 3.18878 10.493 3.1133 10.6752C3.03782 10.8574 2.99931 11.0528 3.00001 11.25V20.25C3.00001 20.4489 3.07903 20.6397 3.21968 20.7803C3.36033 20.921 3.5511 21 3.75001 21H9.75001C9.94892 21 10.1397 20.921 10.2803 20.7803C10.421 20.6397 10.5 20.4489 10.5 20.25V15H13.5V20.25C13.5 20.4489 13.579 20.6397 13.7197 20.7803C13.8603 20.921 14.0511 21 14.25 21H20.25C20.4489 21 20.6397 20.921 20.7803 20.7803C20.921 20.6397 21 20.4489 21 20.25V11.25C21.0007 11.0528 20.9622 10.8574 20.8867 10.6752C20.8112 10.493 20.7003 10.3277 20.5603 10.1887ZM19.5 19.5H15V14.25C15 14.0511 14.921 13.8603 14.7803 13.7197C14.6397 13.579 14.4489 13.5 14.25 13.5H9.75001C9.5511 13.5 9.36033 13.579 9.21968 13.7197C9.07903 13.8603 9.00001 14.0511 9.00001 14.25V19.5H4.50001V11.25L12 3.75L19.5 11.25V19.5Z" />
          </svg>

          <span
            class="dark:text-white"
            v-if="openSidebar"
          >
            Home
          </span>
        </a>

        <button
          type="button"
          class="flex gap-[8px] items-center hover:opacity-70 transition-all whitespace-nowrap"
          :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          @click="toggleTheme(isDark = !isDark)"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" class="dark:fill-white fill-gray-800 flex-shrink-0" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.25 3.75V1.5C11.25 1.30109 11.329 1.11032 11.4697 0.96967C11.6103 0.829018 11.8011 0.75 12 0.75C12.1989 0.75 12.3897 0.829018 12.5303 0.96967C12.671 1.11032 12.75 1.30109 12.75 1.5V3.75C12.75 3.94891 12.671 4.13968 12.5303 4.28033C12.3897 4.42098 12.1989 4.5 12 4.5C11.8011 4.5 11.6103 4.42098 11.4697 4.28033C11.329 4.13968 11.25 3.94891 11.25 3.75ZM18 12C18 13.1867 17.6481 14.3467 16.9888 15.3334C16.3295 16.3201 15.3925 17.0892 14.2961 17.5433C13.1997 17.9974 11.9933 18.1162 10.8295 17.8847C9.66557 17.6532 8.59647 17.0818 7.75736 16.2426C6.91824 15.4035 6.3468 14.3344 6.11529 13.1705C5.88378 12.0067 6.0026 10.8003 6.45672 9.7039C6.91085 8.60754 7.67988 7.67047 8.66658 7.01118C9.65327 6.35189 10.8133 6 12 6C13.5908 6.00174 15.1159 6.63444 16.2407 7.75928C17.3656 8.88412 17.9983 10.4092 18 12ZM16.5 12C16.5 11.11 16.2361 10.24 15.7416 9.49993C15.2471 8.75991 14.5443 8.18314 13.7221 7.84254C12.8998 7.50195 11.995 7.41283 11.1221 7.58647C10.2492 7.7601 9.44736 8.18868 8.81802 8.81802C8.18868 9.44736 7.7601 10.2492 7.58647 11.1221C7.41283 11.995 7.50195 12.8998 7.84254 13.7221C8.18314 14.5443 8.75991 15.2471 9.49993 15.7416C10.24 16.2361 11.11 16.5 12 16.5C13.1931 16.4988 14.337 16.0243 15.1806 15.1806C16.0243 14.337 16.4988 13.1931 16.5 12ZM5.46938 6.53063C5.61011 6.67136 5.80098 6.75042 6 6.75042C6.19902 6.75042 6.38989 6.67136 6.53063 6.53063C6.67136 6.38989 6.75042 6.19902 6.75042 6C6.75042 5.80098 6.67136 5.61011 6.53063 5.46938L5.03062 3.96938C4.88989 3.82864 4.69902 3.74958 4.5 3.74958C4.30098 3.74958 4.11011 3.82864 3.96938 3.96938C3.82864 4.11011 3.74958 4.30098 3.74958 4.5C3.74958 4.69902 3.82864 4.88989 3.96938 5.03062L5.46938 6.53063ZM5.46938 17.4694L3.96938 18.9694C3.82864 19.1101 3.74958 19.301 3.74958 19.5C3.74958 19.699 3.82864 19.8899 3.96938 20.0306C4.11011 20.1714 4.30098 20.2504 4.5 20.2504C4.69902 20.2504 4.88989 20.1714 5.03062 20.0306L6.53063 18.5306C6.60031 18.4609 6.65558 18.3782 6.6933 18.2872C6.73101 18.1961 6.75042 18.0985 6.75042 18C6.75042 17.9015 6.73101 17.8039 6.6933 17.7128C6.65558 17.6218 6.60031 17.5391 6.53063 17.4694C6.46094 17.3997 6.37822 17.3444 6.28717 17.3067C6.19613 17.269 6.09855 17.2496 6 17.2496C5.90145 17.2496 5.80387 17.269 5.71283 17.3067C5.62178 17.3444 5.53906 17.3997 5.46938 17.4694ZM18 6.75C18.0985 6.75008 18.1961 6.73074 18.2871 6.6931C18.3782 6.65546 18.4609 6.60025 18.5306 6.53063L20.0306 5.03062C20.1714 4.88989 20.2504 4.69902 20.2504 4.5C20.2504 4.30098 20.1714 4.11011 20.0306 3.96938C19.8899 3.82864 19.699 3.74958 19.5 3.74958C19.301 3.74958 19.1101 3.82864 18.9694 3.96938L17.4694 5.46938C17.3644 5.57427 17.2928 5.70796 17.2639 5.85352C17.2349 5.99908 17.2497 6.14998 17.3065 6.28709C17.3633 6.42421 17.4596 6.54139 17.583 6.62379C17.7065 6.70619 17.8516 6.75012 18 6.75ZM18.5306 17.4694C18.3899 17.3286 18.199 17.2496 18 17.2496C17.801 17.2496 17.6101 17.3286 17.4694 17.4694C17.3286 17.6101 17.2496 17.801 17.2496 18C17.2496 18.199 17.3286 18.3899 17.4694 18.5306L18.9694 20.0306C19.0391 20.1003 19.1218 20.1556 19.2128 20.1933C19.3039 20.231 19.4015 20.2504 19.5 20.2504C19.5985 20.2504 19.6961 20.231 19.7872 20.1933C19.8782 20.1556 19.9609 20.1003 20.0306 20.0306C20.1003 19.9609 20.1556 19.8782 20.1933 19.7872C20.231 19.6961 20.2504 19.5985 20.2504 19.5C20.2504 19.4015 20.231 19.3039 20.1933 19.2128C20.1556 19.1218 20.1003 19.0391 20.0306 18.9694L18.5306 17.4694ZM4.5 12C4.5 11.8011 4.42098 11.6103 4.28033 11.4697C4.13968 11.329 3.94891 11.25 3.75 11.25H1.5C1.30109 11.25 1.11032 11.329 0.96967 11.4697C0.829018 11.6103 0.75 11.8011 0.75 12C0.75 12.1989 0.829018 12.3897 0.96967 12.5303C1.11032 12.671 1.30109 12.75 1.5 12.75H3.75C3.94891 12.75 4.13968 12.671 4.28033 12.5303C4.42098 12.3897 4.5 12.1989 4.5 12ZM12 19.5C11.8011 19.5 11.6103 19.579 11.4697 19.7197C11.329 19.8603 11.25 20.0511 11.25 20.25V22.5C11.25 22.6989 11.329 22.8897 11.4697 23.0303C11.6103 23.171 11.8011 23.25 12 23.25C12.1989 23.25 12.3897 23.171 12.5303 23.0303C12.671 22.8897 12.75 22.6989 12.75 22.5V20.25C12.75 20.0511 12.671 19.8603 12.5303 19.7197C12.3897 19.579 12.1989 19.5 12 19.5ZM22.5 11.25H20.25C20.0511 11.25 19.8603 11.329 19.7197 11.4697C19.579 11.6103 19.5 11.8011 19.5 12C19.5 12.1989 19.579 12.3897 19.7197 12.5303C19.8603 12.671 20.0511 12.75 20.25 12.75H22.5C22.6989 12.75 22.8897 12.671 23.0303 12.5303C23.171 12.3897 23.25 12.1989 23.25 12C23.25 11.8011 23.171 11.6103 23.0303 11.4697C22.8897 11.329 22.6989 11.25 22.5 11.25Z"/>
          </svg>

          <span
            v-if="openSidebar"
          >
            <span v-if="isDark">Light</span>
            <span v-else>Dark</span>
            Mode
          </span>
        </button>

        <a
          :href="communityURL"
          target="_blank"
          class="flex gap-[8px] items-center hover:opacity-70 transition-all hover:!no-underline hover:text-white"
          :aria-label="communityURL ? 'Get help and support' : 'Help and support (link not available)'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" class="dark:fill-white fill-gray-800 flex-shrink-0" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.125 16.875C13.125 17.0975 13.059 17.315 12.9354 17.5C12.8118 17.685 12.6361 17.8292 12.4305 17.9144C12.225 17.9995 11.9988 18.0218 11.7805 17.9784C11.5623 17.935 11.3618 17.8278 11.2045 17.6705C11.0472 17.5132 10.94 17.3127 10.8966 17.0945C10.8532 16.8762 10.8755 16.65 10.9606 16.4445C11.0458 16.2389 11.19 16.0632 11.375 15.9396C11.56 15.816 11.7775 15.75 12 15.75C12.2984 15.75 12.5845 15.8685 12.7955 16.0795C13.0065 16.2905 13.125 16.5766 13.125 16.875ZM12 6.75C9.93188 6.75 8.25 8.26406 8.25 10.125V10.5C8.25 10.6989 8.32902 10.8897 8.46967 11.0303C8.61033 11.171 8.80109 11.25 9 11.25C9.19892 11.25 9.38968 11.171 9.53033 11.0303C9.67099 10.8897 9.75 10.6989 9.75 10.5V10.125C9.75 9.09375 10.7597 8.25 12 8.25C13.2403 8.25 14.25 9.09375 14.25 10.125C14.25 11.1562 13.2403 12 12 12C11.8011 12 11.6103 12.079 11.4697 12.2197C11.329 12.3603 11.25 12.5511 11.25 12.75V13.5C11.25 13.6989 11.329 13.8897 11.4697 14.0303C11.6103 14.171 11.8011 14.25 12 14.25C12.1989 14.25 12.3897 14.171 12.5303 14.0303C12.671 13.8897 12.75 13.6989 12.75 13.5V13.4325C14.46 13.1184 15.75 11.7544 15.75 10.125C15.75 8.26406 14.0681 6.75 12 6.75ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7661 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z"/>
          </svg>

          <span
            class="dark:text-white"
            v-if="openSidebar"
          >
            Help
          </span>
        </a>
      </nav>

    </aside>
    <!--
    <div class="hamburger-menu hidden" @click="showMenu()">
      <svg aria-label="Sidebar Toggle" role="button" aria-live="polite" id="hamburger-icon" class="float-left hamburger-icon" tabindex="0" width="40px" height="40px" viewBox="-0.5 0 25 25" fill="#23ffffff" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 12.32H22" :stroke="isDark ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2 18.32H22" :stroke="isDark ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2 6.32001H22" :stroke="isDark ? '#ffffff' : '#000000'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <transition name="dialog-fade-expand">
      <div
            ref="dialog"
            class="dialog-container"
            :class="{'open': isDialogVisible}"
            tabindex="-1"
      >
        <div class="sidebar-content-wrapper">
          <p class="theme-mode-toggle-section">
            <span v-if="isDark" aria-live="polite" class="pt-5">Dark Mode</span>
            <span v-else aria-live="polite" class="pt-5">Light Mode</span>
            <span @click="toggleTheme(isDark = !isDark)" class="theme-toggle-icon"></span>
          </p>
          <p class="sidebar-items" v-for="(anchor, index) in sidebarItems" :key="index" v-html="`<u>${anchor}</u>`"></p>

        </div>
      </div>
    </transition>
    -->

    <!-- chatbot side -->
    <div
      class="h-100 chatbot-container"
      :class="{'app-bar': showAppBar, 'show-sidebar': isDialogVisible , 'pl-0 sm:!pl-[300px]': openSidebar , 'pl-0 sm:!pl-[72px]': !openSidebar}"
    >

      <div class="w-[24px] h-[24px] top-[24px] right-[24px] sm:w-[64px] sm:h-[64px] fixed sm:top-[28px] sm:right-[28px] overflow-hidden rounded-full">
        <div ref="announcement" aria-live="assertive" class="sr-only"></div>

          <!-- <img ref="logoImage" :src="logoURL" class="top-logo custom-logo" :alt="community.content && community.content.parameter2 ? community.content.parameter2 : 'Community Logo'" v-if="logoURL && !desktopScreen" @load="fadeIn"> -->
          <a
            :href="communityURL"
            target="_blank"
            :aria-label="communityURL ? `Go to ${community.content && community.content.parameter2 ? community.content.parameter2 : 'community'} home page` : 'Community logo (link not available)'"
          >
            <img ref="logoImage" :src="iconURL" class="top-logo custom-logo" :alt="community.content && community.content.parameter2 ? community.content.parameter2 : 'Community Logo'" v-if="iconURL" @load="fadeIn">
          </a>

        </div>

            <!-- <template v-if="isBeforRequest || isShowChatbot"> -->
              <!-- <h1 class="template-title common-space-from-logo">What do you need help with?</h1> -->
              <!-- <div v-if="community.content && community.content.requestIntroduction" > -->
                <!-- <p class="custom-content mb35" v-html="community.content.requestIntroduction"></p> -->
              <!-- </div> -->
            <!-- </template> -->
            <template v-if="this.isShowChatbot">
              <!-- Chatbot Iframe -->
              <iframe
                ref="botIframe"
                v-if="loaded"
                :src="iframe.src"
                :id="'botkit_client'"
                :style="iframe.style"
                :title="`${community.content && community.content.parameter2 ? community.content.parameter2 : 'Chatbot'} conversation interface`"
                frameborder="0"
                class="chatbot-iframe min-h-full"
              ></iframe>
            </template>
            <!-- <template v-else-if="isBeforRequest && !isSubmitForm">
              <CommunityRequestForm :community="community" :ask="ask" @isBeforRequest="isBeforRequest = value" :checkMemberStatus="checkMemberStatus" />
            </template>
            <template v-else-if="!isBeforRequest && !isSubmitForm">
              <CommunityRequestReviewPage :community="community" :ask="ask" @submitAsk="createAsk" @editAsk="isBeforRequest = true"/>
            </template> -->
            <template v-if="this.isSubmitForm && !this.unsubscribe && !this.spamEmail && !this.invalidMember">
                <div class='header-text common-space-from-logo text-center unsubscribepage-thankumsg darken-request-confirmation mt-30'>
                    <h1 class="box-heading thankyou-template-title">Fabulous!</h1>
                    <div v-if="community.content && community.content.requestPageThankYou" class="box-sub-heading text-left content-textleft thankyou-custom-content" v-html="community.content.requestPageThankYou"></div>
                    <div v-else class="box-sub-heading text-left content-textleft thankyou-custom-content">We will now recruit the right experts to help you.</div>
                </div>
            </template>
            <template v-if="this.unsubscribe && this.isSubmitForm">
                <div class='header-text common-space-from-logo text-center unsubscribepage-thankumsg mt-30'>
                    <div class="box-sub-heading thankyou-custom-content content-textleft text-warning">Your email address has been unsubscribed.</div>
                </div>
            </template>
            <template v-if="this.spamEmail && this.isSubmitForm">
                <div class='header-text common-space-from-logo text-center unsubscribepage-thankumsg mt-30'>
                    <div class="box-sub-heading thankyou-custom-content content-textleft spam-email">Your email address has been blocked.</div>
                </div>
            </template>
            <template v-if="this.invalidMember && this.isSubmitForm">
                <div class='header-text common-space-from-logo text-left unsubscribepage-thankumsg mt-30 chatbot-invalid-member'>
                    <h1 class="box-heading thankyou-template-title">Ooops. We’re really sorry.</h1>
                    <div class="box-sub-heading thankyou-custom-content text-left content-textleft chatbot-custom-content" v-html="finalInvalidMemberMessage"></div>
                </div>
            </template>
            <!-- <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" tabindex="0">Learn More</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" tabindex="0">Terms Of Use [pdf]</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                        </li>
                        <li>
                            <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                            <a href="javascript:void(0)" v-else>Opt Out</a>
                        </li>
                  </ul>
                    <div class="unsubscribe-community-logo">
                        <a href="https://www.protopia.co" target="_blank"><img :src="footerLogoURL" alt='Community Logo'></a>
                    </div> -->
    </div>
  </div>
</template>


<!-- Script-->
<script>
import API from "../services/API";
// sanitize helpers removed (not used in this component)
import Member from "./Member";
import CommunityRequestReviewPage from "./CommunityRequestReviewPage";
import CommunityRequestForm from "./__CommunityRequestForm";
import {Botkit} from '../assets/js/chatbot/embed';
import ThemeTogglerButton from "./ThemeTogglerButton";
import { getLogoURL } from "../helpers/getCustomSettings";
import { MajorFieldsMixin } from '../helpers/majorsHelper';

export default {
	mixins: [MajorFieldsMixin],
	components: {
		Member,
		CommunityRequestReviewPage,
		CommunityRequestForm,
    ThemeTogglerButton
	},
  	props: ["community_id", "sourceparam"],
	data() {
		return {
			api: new API(),
      		ask: {},
      isMobile: '',
			community: {},
      communityURL: '',
      communityTitle: '',
			fullPage: true,
			message: "",
			isBeforRequest: true,
			isShowChatbot: true,
			isSubmitForm: false,
			configureFields: {},
			dynamicFields: {},
			newAdmin: [],
			unsubscribe: false,
			spamEmail: false,
			memberThankYou: "",
			iconURL: '',
			logoURL: '',

			footerLogoURL: "",
			adviceArea: {},
			loaded: false,
      askResponse: {},
      interests: '',
			iframe: {
				src: `${process.env.API_BASEURL}chatbot/${this.community_id}${this.sourceparam ? '?circle=' + encodeURIComponent(this.sourceparam) : ''}`,
				style: null
			},
            invalidMember: false,
            finalInvalidMemberMessage: "",
			channelType: "Chatbot",
			actionPage: 'defPage',
      referenceInterest: [],
      isDark: true,
      showAppBar: false,
      isDialogVisible: false,
  liveAnnouncement: '',
  title: '',
      desktopScreen: false,
      appBar: null,
      sidebarItems: [],
      //
  openSidebar: false,
  circleId: ''
		};
    },
	async created() {
    await this.loadData();
		let options = {};
		Botkit.boot(options)

	},
  	mounted() {
		// this.iframe.style = {
		// 	height: "400px",
    //   "min-height": "400px",
		// }
    this.isMobile = /Mobi|Android/i.test(navigator.userAgent);
		//this.loaded = true;
    this.appBar = document.getElementsByClassName('chatbot-container')[0];
		window.addEventListener("message", (event) => {
      if (event.data.preparedRequest) {
        let preparedRequest = event.data.preparedRequest;
        this.ask = preparedRequest;
        this.createAsk();
      } if (event.data.action === 'setTheme') {
        var iframe = document.getElementById('botkit_client');
        if (iframe && iframe.contentWindow) {
          // send improved contrast colors to iframe
          iframe.contentWindow.postMessage({
            isDark: event.data.isDark,
            accessibilityFix: {
              enabled: true,
              fixes: [
                {
                  selector: '.text-4xl p, #communityName, .community-name',
                  property: 'color',
                  lightValue: '#374151',
                  darkValue: '#E5E7EB'
                }
              ]
            },
            accessibleColors: {
              textOnWhite: '#374151',
              textDark: '#111827',
              textLight: '#F3F4F6'
            }
          }, "*");
          // Try to apply fixes directly if iframe is same-origin
          try { this.applyLocalIframeFixes(iframe); } catch (e) { /* ignore cross-origin */ }
        }
      }
      if (event.data.showAppBar) {
        this.showAppBar = event.data.showAppBar;
        if (!this.appBar.classList.contains('app-bar')) {
          this.desktopScreen = false;
        }
        var appBarImage = this.$refs.logoImage;
        if (appBarImage) {
          this.$refs.logoImage.classList.add('sm-logo');
        }
      }
      if (event.data.hideDialog) {
        this.isDialogVisible = false;
        this.openSidebar = false;
      }
        if (event.data.initialTheme) {
          if (this.isDark) {
            this.sendPostMessage();
          }
        }
        if (event.data.dynamicChatbotHeight) {
          this.chatbotContainerDynamicHeight();
        }
    }, false);

    if (screen.width < 1024) {
      this.desktopScreen = false;
    } else {
      this.desktopScreen = true;
    }
    document.addEventListener('click', this.handleClickOutside);
    this.chatbotContainerDynamicHeight();
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
      const newColorScheme = event.matches ? "dark" : "light";
      if (newColorScheme === "dark") {
        this.isDark = true;
        //document.body.classList.add("dark-theme");
        document.documentElement.classList.add("dark");
      } else {
        this.isDark = false;
        //document.body.classList.remove("dark-theme");
        document.documentElement.classList.remove("dark");
      }
      this.sendPostMessage();
    });

    window.addEventListener("resize", () => {
      if (screen.width < 1024) {
        this.desktopScreen = false;
        if (this.appBar && this.appBar.classList.contains('app-bar')) {
          this.$refs.logoImage.classList.add('sm-logo');
          // send updated accessibility info on resize when bot iframe exists
          try {
            this.$refs.botIframe.contentWindow.postMessage({
              isAppBarVisible: true,
              isDark: this.isDark,
              accessibilityFix: {
                enabled: true,
                fixes: [
                  {
                    selector: '.text-4xl p, #communityName, .community-name',
                    property: 'color',
                    lightValue: '#374151',
                    darkValue: '#E5E7EB'
                  }
                ]
              },
              accessibleColors: {
                textOnWhite: '#374151',
                textDark: '#111827',
                textLight: '#F3F4F6'
              }
            }, "*");
            this.applyLocalIframeFixes(this.$refs.botIframe);
          } catch (e) { /* may be cross-origin */ }
        }
      } else if (this.appBar && !this.appBar.classList.contains('app-bar')) {
          this.desktopScreen = true;
        }
        this.chatbotContainerDynamicHeight();
    });

    //const hamburgerIcon = document.getElementById('hamburger-icon');
    const asideButton = document.getElementById('aside-button');
    //hamburgerIcon.addEventListener('keyup', (event) => {
    asideButton.addEventListener('keyup', (event) => {
      if (event.key === 'Enter') {
        //this.showMenu();
        this.toggleSidebar();
      }
    })
	},
  watch: {
    $route: "loadData",
    isDialogVisible(newValue) {
      this.handleDialogVisibilityChange(newValue);
    }
  },
  methods: {
		loadData: async function() {
			this.memberThankYou = '';
			await this.api.get(`communities/${this.community_id}/community-request`).then(community => {
				this.community = community.data;
        this.actionPage = this.community.actionPage;
        const customSettings = this.community.customSettings;
        this.sidebarItems = this.community.content.resources ? this.community.content.resources : '';
        this.sidebarItems = this.sidebarItems ? this.sidebarItems.split('\n') : [];
        this.title = this.community.content.parameter2;
        document.title = this.title ? this.title : this.$route.meta.title;
		        this.channelType = this.community.friendlyNames && this.community.friendlyNames.chatbot ? this.community.friendlyNames.chatbot : this.channelType;
				if (this.community.content.requestPageThankYou) {
					const replaceStr = this.community.content.requestPageThankYou.replace(/\n/g, "<br />");
					this.community.content.requestPageThankYou = replaceStr;
				}
				if (this.community.content.memberThankYou) {
					this.memberThankYou = this.community.content.memberThankYou;
				}
				if (community.data.content && community.data.content.configureFields) {
					this.configureFields = community.data.content.configureFields;
				}
        if (this.community.customSettings && this.community.customSettings.iconURL !== "") {
          this.iconURL = this.community.customSettings.iconURL;
        } else if (this.community.customSettings && this.community.customSettings.logoURL !== "") {
              this.iconURL = this.community.customSettings.logoURL;
            } else {
					this.iconURL = process.env.LOGO_URL;
				}
				this.logoURL = getLogoURL(customSettings);
				let re = new RegExp(`\\{\\{\\s?community.email\\s?\\}\\}`, 'gi');
       			this.finalInvalidMemberMessage = this.community.content.invalidMemberMessage.replace(re, (this.community.sender && this.community.sender.address) ? this.community.sender.address : process.env.DEFAULT_EMAIL);

        this.communityURL = this.community.communitySite;

			});
      // keep circleId in sync (other components use sourceparam)
      this.circleId = this.sourceparam || '';
      // ensure iframe uses circle param if provided (update in case sourceparam came from route/parent)
      this.iframe.src = `${process.env.API_BASEURL}chatbot/${this.community_id}${this.sourceparam ? '?circle=' + encodeURIComponent(this.sourceparam) : ''}`;
      await this.api.get(`communities/${this.community_id}/get-action-page/?circle=${this.circleId}`).then(actionPage => {
                    if (actionPage.data) {
                      this.actionPage = actionPage.data;
                    } else {
                        this.actionPage = 'defPage';
                    }
      });
      this.getSystemTheme(this.isDark);
      // Wait for iframe to be ready
      this.waitForIframe((iframe) => {
          if (iframe) {
              // console.log('Iframe found:', this.communityTitle);
              iframe.addEventListener('load', () => {
                  console.log('Iframe loaded:', this.communityTitle);
                  if (iframe.contentWindow) {
                      iframe.contentWindow.postMessage({
                        isDark: this.isDark,
                        communityName: this.community.content.parameter2,
                        communityData: this.community,
                        isMobile: this.isMobile,
                        accessibilityFix: {
                          enabled: true,
                          fixes: [
                            {
                              selector: '.text-4xl p, #communityName, .community-name',
                              property: 'color',
                              lightValue: '#374151',
                              darkValue: '#E5E7EB'
                            }
                          ]
                        },
                        accessibleColors: {
                          textOnWhite: '#374151',
                          textDark: '#111827',
                          textLight: '#F3F4F6'
                        }
                      }, "*");
                      try { this.applyLocalIframeFixes(iframe); } catch (e) { /* ignore cross-origin */ }
                  }
              });
          } else {
              console.error('Iframe not found after retries');
          }
      });
      document.body.style.overflow = 'hidden';
      this.loaded = true;
		},
    async createAsk() {
      try {
        // Prepare the ask object
        this.ask.type = 'chatbot';
        this.ask.actionPage = this.actionPage;
        // attach circle/sourceparam so backend receives the circle (consistent with other pages)
        this.ask.sourceparam = this.sourceparam || this.circleId;
        // Ensure majors are cleaned before sending
        this.cleanMajorFields();

        // Create the ask
        const createAskResponse = await this.api.post(`communities/${this.community_id}/create-ask/`, this.ask);
        this.askResponse = createAskResponse.data;
        const askID = createAskResponse.data._id;

        this.ask.interests = this.ask.interests ? this.ask.interests.split(', ') : [];
        if (this.ask.interests && this.ask.interests.length > 0) {
          await this.updateInterests(this.ask.interests);
        }

        if (createAskResponse.status === 200 && this.community.rules.workflow.moduleResources) {
          const resourcesResponse = await this.api.get(`asks/${askID}/get-resources`);
          //console.log(resourcesResponse.data);
          var iframe = document.getElementById('botkit_client');
          if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage({ resources: resourcesResponse.data }, '*');
          }

        } else {
          console.error('Error creating ask: ', createAskResponse.data);
        }

      } catch (error) {
        console.error('Error during API calls: ', error.message);
      }
    },
		tempRequestStore: async function() {
			this.ask.community = this.community._id;
        // Clean majors to avoid sending empty or over-limit majors
        this.cleanMajorFields();
        this.ask.dynamicFields = this.dynamicFields;
			this.ask.channelType = this.channelType;
			this.ask.sourceparam = this.sourceparam;
			this.ask.reason = true;
			this.ask.request_type = 'chat_bot';
			await this.api.post(`asks/${this.community_id}/create-temp-request/`, this.ask).then(response => {});
		},
		deleteTempRequest: async function() {
			await this.api.post(`asks/${this.community_id}/delete-temp-request/`, this.ask).then(response => {});
		},
		callTrackEvent(ask) {
			this.$gtm.enable(true)
			this.$gtm.trackEvent({
				'RequestID': ask._id,
				'RequestSource': 'Chatbot',
				'RequestReceived': this.$moment(ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
				'Community': this.community.name,
				'event': 'RequestSubmitted'
			});
		},
		checkMemberStatus: function() {
			this.api.post(`communities/${this.community_id}/get-member-details/`, this.ask)
				.then(async ask => {
					this.unsubscribe = this.spamEmail = this.invalidMember = false;
					if (ask.data.unsubscribe) {
						this.unsubscribe = true;
					}
					if (ask.data.spamEmail) {
						this.spamEmail = true;
					}
					if (ask.data.invalidMember || ask.data.inactiveMember) {
						this.invalidMember = true;
					}
				})
		},
  updateInterests: async function(interests) {
      var memberUpdateData = {
                requestId: this.askResponse._id,
                giveId: null,
                communityId: this.community._id,
                community: this.community.name,
                circleId: this.ask.sourceparam,
                memberId: this.askResponse.askCreator._id,
                propertyId: this.askResponse.askCreator.propertyId,
                name: this.askResponse.askCreator.displayName,
                email: this.askResponse.askCreator.emails.toString().toLowerCase(),
                memberObj: this.askResponse.askCreator,
                callFrom: 'create-request-page'
            };
            memberUpdateData.memberObj.interests = interests;
            await this.api.post(`members/profile-update`, memberUpdateData).then(response => {
              console.log("Interests added successfully", response.data);
            });

    },
    fadeIn() {
      const image = this.$refs.logoImage;
      image.style.opacity = 1;
    },
    getSystemTheme: function() {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          //document.body.classList.add('dark-theme');
          document.documentElement.classList.add('dark');
          this.isDark = true;
          this.toggleTheme(this.isDark);
      } else {
        this.isDark = false;
      }

    },
    toggleTheme: function(isDark) {
      //var body = document.body;
      var body = document.documentElement;
      if (isDark) {
        //body.classList.add('dark-theme');
        body.classList.add('dark');
      } else {
        //body.classList.remove('dark-theme');
        body.classList.remove('dark');
      }
      this.sendPostMessage();
    },
    sendPostMessage: function() {
      var iframe = document.getElementById('botkit_client');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({
          isDark: this.isDark,
          communityName: this.community.content.parameter2,
          communityData: this.community,
          accessibilityFix: {
            enabled: true,
            fixes: [
                {
                selector: '.text-4xl p, #communityName, .community-name',
                property: 'color',
                lightValue: '#6B7280', // WCAG AA compliant color for light backgrounds
                darkValue: '#D1D5DB' // WCAG AA compliant color for dark backgrounds
              }
            ]
          },
          accessibleColors: {
            textOnWhite: '#6B7280', // Better contrast gray for text on white backgrounds
            textDark: '#1F2937', // Dark gray for better readability
            textLight: '#F9FAFB' // Light text for dark backgrounds
          }
        }, "*");
      }
    },
    // Toggle Sidebar
    toggleSidebar: function() {
      this.openSidebar = !this.openSidebar;
      var message = this.isDialogVisible ? 'Sidebar Expanded' : 'Sidebar Collapsed';
      this.announceMessage(message);
    },
    /*showMenu: function(){
      this.isDialogVisible = !this.isDialogVisible;
      var message = this.isDialogVisible ? 'Sidebar Expanded' : 'Sidebar Collapsed';
      this.announceMessage(message);
    },*/
    handleClickOutside(event) {
      const dialog = this.$refs.dialog;
      //if (this.isDialogVisible && !dialog.contains(event.target) && !event.target.classList.contains('hamburger-icon')) {
      if (this.isDialogVisible && !dialog.contains(event.target) && !event.target.classList.contains('aside-button')) {
        this.isDialogVisible = false;
      }
    },
    handleDialogVisibilityChange(isVisible) {
      if (isVisible) {
        this.liveAnnouncement = 'Dialog opened';
        this.$nextTick(() => {
          this.$refs.dialog.focus();
        });
      } else {
        this.liveAnnouncement = 'Dialog closed';
      }
      this.announce();
    },
    announce() {
      const announcementElement = this.$refs.announcement;
      announcementElement.innerText = this.liveAnnouncement;
    },
    announceMessage(message) {
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('role', 'alert');
        liveRegion.innerText = message;
        document.body.appendChild(liveRegion);
        setTimeout(() => {
          liveRegion.remove();
        }, 1000)
    },
    chatbotContainerDynamicHeight() {
      let height = window.innerHeight;
      document.getElementsByClassName('chatbot-container')[0].style.height = height + 'px';
    },
    waitForIframe(callback, interval = 100, retries = 10) {
        let attempts = 0;
        const checkIframe = setInterval(() => {
            var iframe = document.getElementById('botkit_client');
            if (iframe || attempts >= retries) {
                clearInterval(checkIframe);
                callback(iframe);
            }
            attempts++;
        }, interval);
  },
  applyLocalIframeFixes(iframe) {
      if (!iframe) return;
      try {
        const idoc = iframe.contentDocument || iframe.contentWindow.document;
        if (!idoc) return;
        const existing = idoc.getElementById('a11y-contrast-fixes');
        if (existing) existing.remove();
        const style = idoc.createElement('style');
        style.id = 'a11y-contrast-fixes';
        style.textContent = `
          .text-4xl p, #communityName, .community-name { color: #374151 !important; }
          .dark .text-4xl p, .dark #communityName, .dark .community-name { color: #E5E7EB !important; }
        `;
        idoc.head.appendChild(style);
        // Log for debugging (won't break in production)
        try { console.log('Applied local iframe accessibility fixes'); } catch (e) {}
      } catch (err) {
        // likely cross-origin — ignore silently
      }
    }
  }
};
</script>
<!-- Import TailwindCSS file only for chatbot page -->
<style scoped src="../output.css"></style>
<style>
	.update-request-form-common .btn-feedbackupdatenew.active {
		color: var(--submitBtn-color);
		background-color: var(--submitBtn-background-color);
	}
	.update-request-form-common .btn-feedbackupdatenew {
		color: var(--editBtn-color);
		background-color: var(--editBtn-background-color);
	}
  #message_window form {
    width: 100% !important;
  }

  /* Accessibility fixes for chatbot iframe content */
  iframe#botkit_client {
    /* These styles will be inherited by iframe content in some browsers */
    color-scheme: light dark;
  }
</style>


<style>
  /* Fix gray text elements that fail WCAG AA contrast */
  #botkit_client .text-4xl p,
  #botkit_client #communityName,
  #botkit_client .community-name,
  #botkit_client .text-gray-400,
  #botkit_client #char_count {
    color: #4B5563 !important; /* gray-600 - WCAG AA compliant */
  }

  /* Fix green text contrast */
  #botkit_client .text-green {
    color: #059669 !important; /* emerald-600 - WCAG AA compliant */
  }

  /* Ensure dark mode has proper contrast too */
  .dark #botkit_client .text-4xl p,
  .dark #botkit_client #communityName,
  .dark #botkit_client .community-name,
  .dark #botkit_client .text-gray-400,
  .dark #botkit_client #char_count {
    color: #E5E7EB !important; /* gray-200 - WCAG AA compliant on dark */
  }
</style>


<style>
  /* Fix gray text elements that fail WCAG AA contrast */
  #botkit_client .text-4xl p,
  #botkit_client #communityName,
  #botkit_client .community-name,
  #botkit_client .text-gray-400,
  #botkit_client #char_count {
    color: #4B5563 !important; /* gray-600 - WCAG AA compliant */
  }

  /* Fix green text contrast */
  #botkit_client .text-green {
    color: #059669 !important; /* emerald-600 - WCAG AA compliant */
  }

  /* Fix red text on gray background */
  #botkit_client .inline-block[style*="color: rgb(239, 68, 68)"] {
    color: #DC2626 !important; /* red-600 - better contrast */
  }

  /* Dark mode fixes */
  .dark #botkit_client .text-4xl p,
  .dark #botkit_client #communityName,
  .dark #botkit_client .community-name,
  .dark #botkit_client .text-gray-400,
  .dark #botkit_client #char_count {
    color: #E5E7EB !important; /* gray-200 - WCAG AA compliant on dark */
  }
</style>



// WEBPACK FOOTER //
// src/components/CommunityChatbotRequestPage.vue